// removed by extract-text-webpack-plugin
module.exports = {"wolf":"#dcdee2","minWidth":"1000px","minHeight":"500px","sidebarWidth":"242px","this":"AppLayout__this___1edwK","bodyPadding":"AppLayout__bodyPadding___iF1ro","heightSetter":"AppLayout__heightSetter___2Ivas","banner":"AppLayout__banner___3DSsy","contentWrap":"AppLayout__contentWrap___1I-G_","sidebar":"AppLayout__sidebar___2X7rF","content":"AppLayout__content___28FgI"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/styles/AppLayout.css
// module id = 2373
// module chunks = 0 1